import { Component } from '@angular/core';
import { MissionRulesComponent } from 'src/app/components/missions/mission-rules/mission-rules.component';
import { TournamentRulesComponent } from 'src/app/components/tournaments/tournament-rules/tournament-rules.component';
import { MissionDetailsService } from 'src/app/services/missions/mission-details.service';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';

@Component({
  selector: 'app-how-mission-works',
  templateUrl: './how-mission-works.component.html',
  styleUrls: ['./how-mission-works.component.scss']
})
export class HowMissionWorksComponent extends MissionRulesComponent {

  constructor(
    protected tournamentDetails: MissionDetailsService

  ) {
    super(
      tournamentDetails
    )
  }

  ngOnInit(): void {
    this.getDetails();
  }

}
